import React from "react";
import { PlusMenu } from "./PlusMenu";
import { SearchAction } from "./SearchAction";

export const AgentsActions: React.FC = () => {
  return (
    <>
      <PlusMenu allowedTypes={["agent", "interface", "fluxbot"]} />
      <SearchAction />
    </>
  );
};
